import React, { Fragment, useState } from "react"
import { Table } from "react-bootstrap"
import {  getDateWithHour } from "../../utils"
import ModalConfirmaSerie from "./ModalConfirmaSerie"

const TableUsersRegistrados = ({ users, setUsers }) => {
  const [showModalSerie, setShowModalSerie] = useState(false)
  const [userConfirmaSerie, setUserConfirmaSerie] = useState({})

  const openModalConfirmaSerie = (user) => {
    setUserConfirmaSerie(user)
    setShowModalSerie(true)
  }

  const updateUser = (userId, value) => {
    const newUsers = users.map(x=> {
      if(x.id.toString() === userId.toString() ){
        return {...x, serie_confirmada: value}
      }else{
        return x
      }
    })
    setUsers(newUsers)
  }
  
  
	const DivConfirmaSerie = user => {
		const styleLink = { cursor: "pointer", fontSize: 90 + "%" }

    if(user.ingreso === 'Clave Única') return <b className="text-success">CONFIRMADO</b>
		if (user.serie_confirmada) {
			return (
				<Fragment>
					<b className="text-success">CONFIRMADO</b>
					<br />
					<span
						className="a-link"
						onClick={() => openModalConfirmaSerie(user)}
						style={styleLink}
					>
						Cambiar confirmación
					</span>
				</Fragment>
			)
		} else {
			return (
				<Fragment>
					<b className="text-warning">
						SIN CONFIRMAR <br />
					</b>
					<span className="a-link" onClick={() => openModalConfirmaSerie(user)} style={styleLink}>
						Validar documento
					</span>
				</Fragment>
			)
		}
	}

	return (
    <Fragment>

		<Table bordered responsive>
			<thead className="">
				<tr>
					<th colSpan="7">Registro de usuarios que han iniciado sesión en el sistema</th>
				</tr>
			</thead>
			<thead>
				<tr>
					<th>N°</th>
					{/* <th>ID</th> */}
					<th>Tipo Ingreso</th>
					<th>Cédula confirmada</th>
					<th>RUN</th>
					<th>Nombre Completo</th>
					<th>Estado Voto</th>
					<th>Fecha Voto</th>
				</tr>
			</thead>
			<tbody>
				{users?.map((user, index) => {
          return (
            <tr key={index}>
							<td>{index + 1}</td>
							<td>{user.ingreso}</td>
							<td className="text-center">{DivConfirmaSerie(user)}</td>
							<td>{user.run}</td>
							<td>{user.nombres + " " + user.paterno + " " + user.materno}</td>
							<td className="text-center">
								{user.voto_emitido ? "EMITIDO" : "---------------"}
							</td>
							{/* TODO: cambiar a fecha de votacion */}
							<td>{getDateWithHour(user.fecha_voto)}</td>
						</tr>
					)
				})}
			</tbody>
		</Table>
    <ModalConfirmaSerie refresh={updateUser} show={showModalSerie} setShow={setShowModalSerie} user={userConfirmaSerie}/>
        </Fragment>
	)
}

export default TableUsersRegistrados
